// src/locales/ta/messageCenterShifts.js
export const messageCenterShifts = {
  pageTitle: 'செய்தி மைய ஷிப்ட்கள்',
  pageDescription: 'ஷிப்ட்களை திட்டமிடவும், தலைவரையும் ஊழியர்களையும் நியமிக்கவும், பணி நேரங்களைக் கண்காணிக்கவும்',
  newShift: 'புதிய ஷிப்ட்',
  editShift: 'ஷிப்ட்டைத் திருத்து',
  createShift: 'ஷிப்ட் உருவாக்கு',
  saveShift: 'ஷிப்ட்டைச் சேமி',
  shiftDate: 'ஷிப்ட் தேதி',
  shiftType: 'ஷிப்ட் வகை',
  shiftLeader: 'ஷிப்ட் தலைவர்',
  targetSalesValue: 'இலக்கு விற்பனை மதிப்பு',
  commissionFlags: 'கமிஷன் கொடிகள்',
  excludeAllFromCommission: 'அனைத்து ஊழியர்களையும் கமிஷனிலிருந்து விலக்கு',
  excludeLeaderFromCommission: 'தலைவரை கமிஷனிலிருந்து விலக்கு',
  shiftStaff: 'ஷிப்ட் ஊழியர்கள்',
  addStaff: 'ஊழியரைச் சேர்',
  staffMember: 'ஊழியர்',
  startTime: 'தொடக்க நேரம்',
  endTime: 'முடிவு நேரம்',
  staffCount: 'ஊழியர் எண்ணிக்கை',
  achievedSalesValue: 'அடைந்த விற்பனை',
  totalCommission: 'மொத்த கமிஷன்',
  detailsPageTitle: 'ஷிப்ட் விவரங்கள்',
  detailsPageDescription: 'இந்த ஷிப்டிற்கான கமிஷன் விவரம், ஆர்டர்கள் மற்றும் செயல்திறன் சுருக்கம்',
  totalOrders: 'மொத்த ஆர்டர்கள்',
  dispatchedOrders: 'அனுப்பப்பட்ட ஆர்டர்கள்',
  settledOrders: 'தீர்க்கப்பட்ட ஆர்டர்கள்',
  salesValue: 'விற்பனை மதிப்பு',
  orderQuantity: 'ஆர்டர் அளவு',
  itemQuantity: 'பொருள் அளவு',
  staffCommissionBreakdown: 'ஊழியர் கமிஷன் விவரம்',
  shiftOrders: 'ஷிப்ட் ஆர்டர்கள்',
  noOrdersForShift: 'இந்த ஷிப்டிற்கு ஆர்டர்கள் இல்லை',
  failedToLoadShiftDetails: 'ஷிப்ட் விவரங்களை ஏற்ற முடியவில்லை',
  failedToLoadShiftOrders: 'ஷிப்ட் ஆர்டர்களை ஏற்ற முடியவில்லை',
  hours: 'மணிநேரம்',
  courierStatus: 'கூரியர் நிலை',
  orderItems: 'Order Items',
  itemsQty: 'Qty',
  commissionCalculation: 'கமிஷன் கணக்கீடு',
  amountPerUnit: 'ஒரு அலகுக்கான தொகை',
  slabQty: 'ஸ்லாப் அளவு',
  slabTotal: 'ஸ்லாப் மொத்தம்',
  searchShiftOrders: 'ஆர்டர் எண், வாடிக்கையாளர், ஏர்வேபில் அல்லது தொலைபேசி எண்ணைத் தேடுங்கள்...',
  orderStatusFilter: 'ஆர்டர் நிலை',
  courierStatusFilter: 'கூரியர் நிலை',
  allStatuses: 'அனைத்து நிலைகளும்',
  searchStatuses: 'நிலைகளைத் தேடு...',
  filterByShiftType: 'ஷிப்ட் வகையால் வடிகட்டு',
  filterByLeader: 'தலைவரால் வடிகட்டு',
  allShiftTypes: 'அனைத்து ஷிப்ட் வகைகள்',
  allLeaders: 'அனைத்து தலைவர்கள்',
  dateFrom: 'தொடக்க தேதி',
  dateTo: 'முடிவு தேதி',
  filterByDateRange: 'ஷிப்ட் தேதி வரம்பு',
  allShiftDates: 'அனைத்து ஷிப்ட் தேதிகள்',
  noShiftsFound: 'ஷிப்ட்கள் எதுவும் இல்லை',
  noShiftsFoundDescription: 'உங்கள் வடிப்பான்களை சரிசெய்யவும் அல்லது புதிய ஷிப்ட் ஒன்றை உருவாக்கவும்',
  noShiftsYet: 'இன்னும் ஷிப்ட்கள் திட்டமிடப்படவில்லை',
  noShiftsYetDescription: 'தொடங்க உங்கள் முதல் ஷிப்ட்டை உருவாக்கவும்',
  shiftCreatedSuccess: 'ஷிப்ட் வெற்றிகரமாக உருவாக்கப்பட்டது',
  shiftUpdatedSuccess: 'ஷிப்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  failedToLoadShifts: 'ஷிப்ட்களை ஏற்ற முடியவில்லை',
  failedToLoadShiftTypes: 'ஷிப்ட் வகைகளை ஏற்ற முடியவில்லை',
  failedToLoadUsers: 'வணிக பயனர்களை ஏற்ற முடியவில்லை',
  failedToSaveShift: 'ஷிப்ட்டை சேமிக்க முடியவில்லை',
  timesResetNote: 'தேர்ந்தெடுக்கப்பட்ட ஷிப்ட் வகையின் இயல்புநிலை நேரங்களுக்கு தொடக்க/முடிவு நேரங்கள் புதுப்பிக்கப்பட்டுள்ளன.',
  selectShiftType: 'ஒரு ஷிப்ட் வகையைத் தேர்ந்தெடுக்கவும்',
  selectLeader: 'ஒரு ஷிப்ட் தலைவரைத் தேர்ந்தெடுக்கவும்',
  selectUser: 'ஒரு பயனரைத் தேர்ந்தெடுக்கவும்',
  removeStaff: 'அகற்று',
  duplicateStaffWarning: 'இந்த பயனர் ஏற்கனவே இந்த ஷிப்ட்டில் சேர்க்கப்பட்டுள்ளார்',
  leaderStaffRowUpdatedNotice: 'புதிய தலைவருக்கு ஏற்ப ஷிப்ட் தலைவரின் ஊழியர் வரிசை புதுப்பிக்கப்பட்டது',
  leaderRowLocked: 'இந்த பயனர் ஷிப்ட் தலைவராக இருப்பதால் இந்த வரிசை தானாகவே நிர்வகிக்கப்படுகிறது',
  edit: 'திருத்து',
  viewDetails: 'விவரங்களைக் காண்க',
  estimate: 'Estimate',
  estimateNote: 'Live estimate — commission values will be final once the shift is finalized',
  selectTime: 'Select time',
  targetSalesValuePlaceholder: 'e.g. 500000',
  validation: {
    shiftDateRequired: 'ஷிப்ட் தேதி தேவை',
    shiftTypeRequired: 'ஷிப்ட் வகை தேவை',
    shiftLeaderRequired: 'ஷிப்ட் தலைவர் தேவை',
    targetSalesValueRequired: 'இலக்கு விற்பனை மதிப்பு தேவை',
    targetSalesValueInvalid: 'இலக்கு விற்பனை மதிப்பு சரியான நேர்மறை எண்ணாக இருக்க வேண்டும்',
    staffUserRequired: 'ஒவ்வொரு வரிசைக்கும் ஒரு ஊழியரைத் தேர்ந்தெடுக்கவும்',
    staffTimeRequired: 'ஒவ்வொரு ஊழியர் வரிசைக்கும் தொடக்க மற்றும் முடிவு நேரம் தேவை',
    fixErrors: 'சேமிப்பதற்கு முன் குறிப்பிடப்பட்ட பிழைகளை சரிசெய்யவும்',
  },
};
